import { connect } from 'react-redux';

import PartnershipAccountScreen from '../components/PartnershipAccountScreen';
import storage from '../../../../../lib/Storage';
import { findStorageType } from '../../../../../lib/Auth';

const mapStateToProps = (state) => {
  return {
    isLoading: state.partnershipAccount.get('isLoading'),
    partnershipId: storage.get(findStorageType(), 'partnershipId'),
    partnershipName: storage.get(findStorageType(), 'partnershipData')?.name,
    access_role_admin_in_app: storage.get(findStorageType(), 'partnershipData')
      ?.access_role_admin_in_app,
    role: storage.get(findStorageType(), 'partnershipData')?.role,
  };
};

const PartnershipAccountScreenContainer = connect(mapStateToProps)(
  PartnershipAccountScreen
);

export default PartnershipAccountScreenContainer;
